import classNames from 'classnames'
import { observer } from 'mobx-react-lite'
import { useState } from 'react'

import { dmsState } from '@/app/store'
import { type ICommonField } from '@/app/types/common'

import { type InputEvent } from '../../helper'

import style from './AutoCompleteInsuranceCompany.module.scss'
import { Notificator } from './Notificator/Notificator'

interface IProps {
    entity: ICommonField
    isDisabled?: boolean
    onSetInsuranceCompanyId: (insuranceCompanyId: string | null) => void
    onTouch: () => void
    isNotificator?: boolean
}

export const AutoCompleteInsuranceCompany = observer((props: IProps) => {
    const { entity, isDisabled, isNotificator, onSetInsuranceCompanyId, onTouch } = props

    const [isShowCompanies, setIsShowCompanies] = useState<boolean>(false)
    const [fieldValue, setFieldValue] = useState<string>(
        dmsState.companiesList?.find((company) => company.id === entity.value)?.name || ''
    )

    const onFocusField = () => {
        setIsShowCompanies(true)
        onTouch()
    }
    const onBlurField = () => {
        setIsShowCompanies(false)
    }
    const onChangeInputValue = (e: InputEvent) => {
        onSetInsuranceCompanyId(null)
        setFieldValue(e.target.value)
    }

    const filteredCompanies =
        dmsState.companiesList?.filter((item) => item.name.toLowerCase().includes(fieldValue.toLowerCase())) || null

    const isError = entity.isTouched && !!entity.error

    if (isNotificator) {
        return <Notificator companyName={fieldValue} />
        // return <div className={style.container}>{fieldValue}</div>
    }

    return (
        <div className={style.container}>
            <div className={style.blockTitle}>
                <span>{entity.name}</span>
            </div>
            <div className={style.inputWrapper}>
                <input
                    className={classNames(style.field, isError && style.fieldError)}
                    type='text'
                    disabled={isDisabled}
                    value={fieldValue}
                    placeholder={entity.placeholder}
                    onChange={onChangeInputValue}
                    onFocus={onFocusField}
                    onBlur={onBlurField}
                />
                {!isDisabled && filteredCompanies && filteredCompanies.length > 0 && isShowCompanies && (
                    <div className={style.items}>
                        {filteredCompanies.map((company) => {
                            const { id, name } = company
                            const onClickCompany = () => {
                                onSetInsuranceCompanyId(id)
                                setFieldValue(name)
                            }
                            return (
                                <div key={id} className={style.item} onMouseDown={onClickCompany}>
                                    <span>{name}</span>
                                </div>
                            )
                        })}
                    </div>
                )}
            </div>
        </div>
    )
})
